import {assetsBaseUrl} from "config"

export const TabTutorial = () => (
  <section>
    <div className="content">
      <img src={`${assetsBaseUrl}/compare-to-reference.png`} className="full-width" alt="Tutorial coming soon" />
      <section>
        <div className="heading size-l">Coming soon</div>
        <div className="content size-m">AI tutorials demonstrated for you live</div>
      </section>
    </div>
  </section>
)
